export const capitalize = (txt: string) => {
	if (!txt) return ""
	return txt.charAt(0).toUpperCase() + txt.slice(1);
};
